const base = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
}

export const ChatIcon = (p) => (
  <svg viewBox="0 0 24 24" width="26" height="26" {...base} {...p}>
    <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12Z" />
    <path d="M8.5 11.5h.01M12 11.5h.01M15.5 11.5h.01" />
  </svg>
)
export const CloseIcon = (p) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...base} {...p}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
)
export const MinusIcon = (p) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...base} {...p}>
    <path d="M5 12h14" />
  </svg>
)
export const SendIcon = (p) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" {...p}>
    <path d="M3.4 20.4 21 12 3.4 3.6l-.1 6.5L15 12 3.3 13.9l.1 6.5Z" />
  </svg>
)
export const ClipIcon = (p) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...base} {...p}>
    <path d="m21 11-8.6 8.6a5 5 0 0 1-7.1-7.1l9-9a3.3 3.3 0 0 1 4.7 4.7l-9 9a1.7 1.7 0 0 1-2.4-2.4l8.3-8.3" />
  </svg>
)
export const StopIcon = (p) => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" {...p}>
    <rect x="5" y="5" width="14" height="14" rx="2" />
  </svg>
)
// export const PlaneIcon = (p) => (
//   <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" {...p}>
//     <path d="M12 1.5c1 0 1.7 1 1.7 2.4V9l8.3 5.2c.3.2.5.5.5.9v.9c0 .4-.4.7-.8.6L13.7 14.5v4.2l2.3 1.7c.2.2.3.4.3.7v.6c0 .3-.3.5-.6.4L12 20.9l-3.7 1.2c-.3.1-.6-.1-.6-.4v-.6c0-.3.1-.5.3-.7l2.3-1.7v-4.2l-7.7 2.1c-.4.1-.8-.2-.8-.6v-.9c0-.4.2-.7.5-.9L10.3 9V3.9C10.3 2.5 11 1.5 12 1.5Z" />
//   </svg>
// )

export const PlaneIcon = (p) => (
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...p}
  >
    <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
  </svg>
)
export const ShieldIcon = (p) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" {...p}>
    <path d="M12 2 4 5v6c0 5 3.4 9.3 8 11 4.6-1.7 8-6 8-11V5l-8-3Zm-1.2 14-3.3-3.3 1.4-1.4 1.9 1.9 4.4-4.4 1.4 1.4-5.8 5.8Z" />
  </svg>
)
export const HeartIcon = (p) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" {...p}>
    <path d="M12 21s-8-4.9-8-11a4.8 4.8 0 0 1 8-3.6A4.8 4.8 0 0 1 20 10c0 6.100-8 11-8 11Z" />
  </svg>
)
export const BotIcon = (p) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...base} {...p}>
    <rect x="4" y="8" width="16" height="12" rx="4" />
    <path d="M12 8V4.5M9 13.5v1M15 13.5v1" />
    <circle cx="12" cy="3.5" r="1" fill="currentColor" />
  </svg>
)
export const PinIcon = (p) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...p}>
    <path d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.800 7-13a7 7 0 0 0-7-7Zm0 9.500A2.500 2.500 0 1 1 12 6.500a2.500 2.500 0 0 1 0 5Z" />
  </svg>
)
export const BedIcon = (p) => (
  <svg viewBox="0 0 24 24" width="16" height="16" {...base} {...p}>
    <path d="M3 18V6M3 14h18v4M21 14v-2a3 3 0 0 0-3-3h-7v5" />
  </svg>
)
export const UsersIcon = (p) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...p}>
    <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm8 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM9 13c-3.300 0-7 1.700-7 4.500V20h14v-2.500C16 14.700 12.300 13 9 13Zm8 .2c-.5 0-1 .1-1.600.2 1.300 1 2.100 2.300 2.100 4.100V20H22v-2.500c0-2.300-2.700-4.300-5-4.300Z" />
  </svg>
)
export const ArrowIcon = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)
export const ChevronIcon = ({ dir = "right", ...p }) => (
  <svg viewBox="0 0 24 24" width="18" height="18" {...base} {...p}>
    <path d={dir === "right" ? "m9 6 6 6-6 6" : "m15 6-6 6 6 6"} />
  </svg>
)
export const StarIcon = (p) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" {...p}>
    <path d="m12 2 3 6.500 7 .8-5.200 4.800 1.400 7L12 17.600 5.800 21.100l1.400-7L2 9.300l7-.8L12 2Z" />
  </svg>
)
export const PercentIcon = (p) => (
  <svg viewBox="0 0 24 24" width="22" height="22" {...base} strokeWidth={2.5} {...p}>
    <path d="M19 5 5 19" />
    <circle cx="7" cy="7" r="2" />
    <circle cx="17" cy="17" r="2" />
  </svg>
)
